import axios from 'axios'
import Auth from './auth'

const API_URL = process.env.REACT_APP_API

export const getStatus = async (id) => {
  const token = await Auth.getIdToken()
  
  const result = await axios.get(`${API_URL}/onBoardWhatsAppStatusV2?organizationId=${id}`, {headers: { Authorization: `Bearer ${token}`}})
  
  return result
}

export const onBoard = async (params) => {
  const token = await Auth.getIdToken()
  
  const result = await axios.post(`${API_URL}/onBoardWhatsAppV2`, params, {headers: { Authorization: `Bearer ${token}`}})
  
  return result
}

export const onBoardRetry = async (params) => {
  const token = await Auth.getIdToken()
  
  const result = await axios.post(`${API_URL}/onBoardRetryV2`, params, {headers: { Authorization: `Bearer ${token}`}})
  
  return result
}

export const createTemplate = async (params) => {
  const token = await Auth.getIdToken()
  
  const result = await axios.post(`${API_URL}/createWhatsAppTemplateV2`, params, {headers: { Authorization: `Bearer ${token}`}})
  
  return result
}

export const updateTemplate = async (params) => {
  const token = await Auth.getIdToken()
  
  const result = await axios.post(`${API_URL}/updateWhatsAppTemplateV2`, params, {headers: { Authorization: `Bearer ${token}`}})
  
  return result
}

export const getTemplates = async (params) => {
  const token = await Auth.getIdToken()
  
  const result = await axios.get(`${API_URL}/getWhatsAppTemplatesV2?organizationId=${params.organizationId}`, {headers: { Authorization: `Bearer ${token}`}})

  return result
}

export const publishTemplate = async (params) => {
  const token = await Auth.getIdToken()
  
  const result = await axios.post(`${API_URL}/publishWhatsAppTemplateV2`, params, {headers: { Authorization: `Bearer ${token}`}})
  
  return result
}